import {
  riskLevels,
  lifecycleStates,
  lifecycleEvents,
  legislativePathIntro,
  committeeRoles,
  dateConfidenceLevels,
} from '../../content/methodology';
import { humanizeEventType } from '../../utils/lifecycleFormat';

export function BadgesLegend() {
  return (
    <section className="badges-legend">
      <h3>Co znamenají odznaky</h3>
      <div className="badges-legend__group">
        <h4>Úroveň rizika</h4>
        <div className="badges-legend__items">
          {riskLevels.map((r) => (
            <div key={r.level} className="badges-legend__item">
              <span className={`risk-badge risk-badge--${r.level}`}>{r.label}</span>
              <span className="badges-legend__item-desc">{r.description}</span>
            </div>
          ))}
        </div>
        <p className="badges-legend__note">
          Nízké riziko neznamená, že návrh je nevýznamný. Znamená pouze, že systém v dostupných datech nenašel výrazný varovný signál.
        </p>
      </div>
      <div className="badges-legend__group">
        <h4>Stav zpracování</h4>
        <div className="badges-legend__items">
          {lifecycleStates.map((s) => (
            <div key={s.state} className="badges-legend__item">
              <span className={`badge badge--state presentation-state--${s.state}`}>{s.label}</span>
              <span className="badges-legend__item-desc">{s.description}</span>
            </div>
          ))}
        </div>
      </div>
      <div className="badges-legend__group">
        <h4>{legislativePathIntro.title}</h4>
        {legislativePathIntro.body.map((p, i) => (
          <p key={i} className="badges-legend__item-desc">
            {p}
          </p>
        ))}
        <div className="badges-legend__items">
          {committeeRoles.map((r) => (
            <div key={r.role} className="badges-legend__item">
              <span className={`committee-role committee-role--${r.role}`}>{r.label}</span>
              <span className="badges-legend__item-desc">{r.description}</span>
            </div>
          ))}
        </div>
        <h4>Jistota termínu</h4>
        <div className="badges-legend__items">
          {dateConfidenceLevels.map((c) => (
            <div key={c.confidence} className="badges-legend__item">
              <span className={`legi-conf legi-conf--${c.confidence}`}>{c.label}</span>
              <span className="badges-legend__item-desc">{c.description}</span>
            </div>
          ))}
        </div>
        <p className="badges-legend__note">{legislativePathIntro.note}</p>
      </div>
      <div className="badges-legend__group">
        <h4>Přílepkové riziko</h4>
        <div className="badges-legend__items">
          <div className="badges-legend__item">
            <span className="badge badge--rider-confirmed">Přílepek</span>
            <span className="badges-legend__item-desc">
              Heuristika i AI upozorňují, že pozměňovací návrh může věcně vybočovat z hlavního tisku.
            </span>
          </div>
          <div className="badges-legend__item">
            <span className="badge badge--rider-possible">Možný přílepek</span>
            <span className="badges-legend__item-desc">
              Některý ze signálů je slabší nebo se AI a heuristika neshodují; jde o upozornění pro ruční kontrolu.
            </span>
          </div>
        </div>
        <p className="badges-legend__note">
          Tyto odznaky nejsou právní stanovisko. Detail návrhu ukazuje, které signály k nim vedly a jaké stanovisko k amendmentu dalo AI.
        </p>
      </div>
      <div className="badges-legend__group">
        <h4>Co znamenají události</h4>
        <div className="badges-legend__items">
          {lifecycleEvents.map((e) => (
            <div key={e.type} className="badges-legend__item">
              <span className="badge badge--trigger">Událost: {humanizeEventType(e.type)}</span>
              <span className="badges-legend__item-desc">{e.description}</span>
            </div>
          ))}
        </div>
        <p className="badges-legend__note">
          Na kartě návrhu se zobrazuje jen poslední událost. Další technické události (zpracování dokumentů, manuální poznámky, chyby) jsou interní a v běžné nápovědě je neuvádíme.
        </p>
      </div>
    </section>
  );
}
